"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*@ngInject*/
exports.default = ['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('new_password', {
            url: '/new-password',
            template: require('../views/new-password.html'),
            controller: 'NewPasswordController',
            controllerAs: 'new_password'
        });
    }];



//////////////////
// WEBPACK FOOTER
// ./scripts/core/password_reset/config/routes.js
// module id = 337
// module chunks = 0